(function () {                                            // Rechtstexte: [Platzhalter] lila markieren
  function markiere(wurzel) {
    var w = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null), n, liste = [];
    while ((n = w.nextNode())) { if (n.parentNode && n.parentNode.closest && n.parentNode.closest('.platzhalter')) continue; if (/\[[^\]]+\]/.test(n.nodeValue)) liste.push(n); }
    liste.forEach(function (n) {
      var t = n.nodeValue, re = /\[[^\]]+\]/g, f = document.createDocumentFragment(), i = 0, m;
      while ((m = re.exec(t))) {
        if (m.index > i) f.appendChild(document.createTextNode(t.slice(i, m.index)));
        var sp = document.createElement('span'); sp.className = 'platzhalter'; sp.textContent = m[0]; f.appendChild(sp);
        i = m.index + m[0].length;
      }
      if (i < t.length) f.appendChild(document.createTextNode(t.slice(i)));
      n.parentNode.replaceChild(f, n);
    });
  }
  function alle() { Array.prototype.forEach.call(document.querySelectorAll('.nd-rechts-bloecke'), markiere); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();
window.NadosEN = window.NadosEN || {}; window.NadosEN['AGB'] = 'Terms & conditions'; window.NadosEN['Widerrufsrecht'] = 'Right of withdrawal';
window.NadosT = function (k) { var o = window.NadosTexte || {}; return (typeof o[k] === 'string' && o[k] !== '') ? o[k] : k; };
// v2.43 Mobil: automatisch weiterscrollen (nur bis 760px Breite)
// v2.92: bei Lieferung erst nach Datum und Uhrzeit, wie bei Abholung
(function () {
  function mobil() { return !!(window.matchMedia && window.matchMedia('(max-width: 760px)').matches); }
  var sperre = 0;
  function scrolle(el, abstand) {
    if (!el || Date.now() - sperre < 800) return;
    sperre = Date.now();
    var kopf = document.querySelector('.site-header');
    var kh = kopf ? Math.max(kopf.getBoundingClientRect().bottom, 0) : 0;
    var y = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - kh - abstand;
    if (y < 0) y = 0;
    try { window.scrollTo({ top: y, left: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
    setTimeout(function () {
      var jetzt = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (Math.abs(jetzt - y) > 40) {
        window.scrollTo(0, y);
        var se = document.scrollingElement || document.documentElement; if (se) se.scrollTop = y;
      }
    }, 900);
  }
  document.addEventListener('click', function (e) {
    if (!mobil() || !e.target.closest) return;
    var t = e.target.closest('#abholuhrzeit-liste button[data-zeit], #abholdatum-kalender button[data-datum]');
    if (t && !t.disabled) {
      setTimeout(function () {
        var a = document.querySelector('.fulfillment-option.active');
        var d = document.getElementById('abholdatum'), z = document.getElementById('abholuhrzeit');
        if (!d || !z || !d.value || !z.value) return;
        var fk = document.activeElement;
        if (fk && fk.blur && /^(INPUT|SELECT|TEXTAREA)$/.test(fk.tagName)) { try { fk.blur(); } catch (e2) {} }
        scrolle(document.querySelector('.donuts-after .box-grid') || document.querySelector('.donuts-after'), 12);
      }, 250);
      return;
    }
    var plus = e.target.closest('[data-auswahl] .q-plus');
    if (plus) {
      var wurzel = plus.closest('[data-auswahl]'), knopf = wurzel && wurzel.querySelector('[data-add]');
      if (knopf && knopf.disabled) {                       // vorher noch nicht voll
        setTimeout(function () {
          if (knopf.disabled) return;                      // erst jetzt voll -> zum Button
          var r = knopf.getBoundingClientRect();
          var y = r.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - (window.innerHeight - r.height) / 2;
          if (y < 0) y = 0;
          try { window.scrollTo({ top: y, left: 0, behavior: 'smooth' }); } catch (e4) { window.scrollTo(0, y); }
        }, 150);
      }
      return;
    }
    var g = e.target.closest('.nd-auswahl-groesse');
    if (g) {
      var root = g.closest('[data-auswahl]');
      setTimeout(function () { scrolle(root && root.querySelector('.nd-auswahl-liste'), 14); }, 120);
    }
  }, true);
})();
